
const sliders = document.querySelectorAll( '.card-slider' );

// Controls active state based on items in viewport
const activeItemsWatcher = new IntersectionObserver( assignActiveState, {
    root: document.body, //Codepen bug with default value?
    rootMargin: '0px',//Allows items to peek through without being 'active'
    threshold: 0.5
} );

// If item is in the viewport, set active else set inactive
function assignActiveState( entries ) {
    entries.forEach( entry => {
        entry.target.dataset.active = entry.isIntersecting;
    } );
}

const items = document.querySelectorAll( '.card-slider__item' );
items.forEach( item => {
    activeItemsWatcher.observe( item );
} );

sliders.forEach( async slider => {
    slider.addEventListener( 'wheel', e => {
        if ( slider.scrollWidth <= slider.clientWidth ) return;
        if ( e.deltaY > 0 && slider.scrollLeft >= slider.scrollWidth - slider.clientWidth ) return;
        else if ( e.deltaY < 0 && slider.scrollLeft === 0 ) return;

        e.preventDefault();
        e.stopPropagation();
        scroller( e );
    }, );

    const container = slider.closest( '[data-slider-container]' );
    if ( !container ) return;
    const nav = container.querySelector( '.card-slider__nav' );
    const nextButton = container.querySelector( '[data-slider-next]' );
    const prevButton = container.querySelector( '[data-slider-prev]' );

    if ( !nextButton || !prevButton ) return;

    await new Promise( ( resolve ) => {
        setTimeout( () => resolve(), 1000 );
    } );

    let nextCard = slider.querySelector( '[data-active=true] + [data-active=false]' );
    let prevCard = slider.querySelector( '[data-active=true]' )?.previousElementSibling;

    slider.addEventListener( 'scroll', setButtonState );
    setButtonState();

    nextButton.addEventListener( 'click', () => {
        slider.querySelector( '[data-active=true] + [data-active=false]' )?.scrollIntoView( { behavior: 'smooth', block: "nearest" } );
        prevCard = nextCard;
        nextCard = slider.querySelector( '[data-active=true] + [data-active=false]' );
        if ( !nextCard ) nextButton.disabled = true;
        prevButton.disabled = false;
    } );
    prevButton.addEventListener( 'click', () => {
        slider.querySelector( '[data-active=true]' )?.previousElementSibling?.scrollIntoView( { behavior: 'smooth', block: "nearest" } );
        nextCard = prevCard;
        prevCard = slider.querySelector( '[data-active=true]' ).previousElementSibling;
        if ( !prevCard ) prevButton.disabled = true;
        nextButton.disabled = false;
    } );

    window.addEventListener( 'resize', debounce( setButtonState, 500 ) );

    function setButtonState() {
        if ( slider.scrollWidth <= slider.clientWidth ) {
            nav.style.display = 'none';
            nav.parentElement.dataset.empty = true;

        } else {
            nav.style.removeProperty('display');
            nav.parentElement.dataset.empty = false;
        }

        if ( slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 10 ) {
            prevButton.disabled = false;
            nextButton.disabled = true;
        } else if ( slider.scrollLeft === 0 ) {
            prevButton.disabled = true;
            nextButton.disabled = false;
        } else {
            nextButton.disabled = false;
            prevButton.disabled = false;
        }
    }

    function scroller( e ) {
        throttle( () => {
            if ( e.deltaY > 0 ) {
                slider.querySelector( '[data-active=true] + [data-active=false]' )?.scrollIntoView( { block: 'nearest' } );
            } else {
                slider.querySelector( '[data-active=true]' )?.previousElementSibling?.scrollIntoView( { block: 'nearest' } );
            }
        }, 800 )();
    }
} );



function throttle( func, limit ) {
    let timeout = false;
    return ( ...funcArgs ) => {
        if ( timeout ) return;
        func( ...funcArgs );
        timeout = setTimeout( () => timeout = false, limit );
    };
}


/**
 * Returns a function that will be executed once after the final function call within the limit
 *
 * @param {callback} func callback function to debounce
 * @param {number} limit in ms
 *
 * @return {function} Your debounced function
 */
export function debounce( func, limit ) {
    let timeout;
    return ( ...args ) => {
        clearTimeout( timeout );
        timeout = setTimeout( func, limit, ...args );
    };
}
